import React, { useState } from "react";
import "./layout.css";

import dashboard from "../../assets/Images/dashboard.png";
import dashboardw from "../../assets/Images/dashboard_white.png";

import MyProjects from "../../assets/Images/MyProjects.png";
import MyProjectsw from "../../assets/Images/MyProjectsw.png";

import ProjectsAllocation from "../../assets/Images/MyProjects.png";
import ProjectsAllocationw from "../../assets/Images/MyProjectsw.png";

import Portfolio from "../../assets/Images/Portfolio.png";
import Portfoliow from "../../assets/Images/Portfolio.png";

import MyApproval from "../../assets/Images/MyApproval.png";
import MyApprovalw from "../../assets/Images/MyApproval.png";

import Setting from "../../assets/Images/setting.png";
import Logout from "../../assets/Images/logout.png";

import logo from "../../assets/Icons/logo.png";

import { NavLink } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

const SideBar = () => {
  const [urls, setUrls] = useState("MyProjects");
  return (
    <div style={{ height: "100%", background: "#FFF" }} id="custom">
      <div className="container px-0">
        <div className="row">
          {/* <div className="col-sm-auto  sticky-top" > */}
          <div className=" sticky-top">
            <div className="d-flex flex-sm-column flex-row flex-nowrap  align-items-center sticky-top">
              <a
                href="/"
                className="d-block p-1 mt-3 link-dark text-decoration-none"
                title=""
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-original-title="Icon-only"
              >
                <img src={logo} style={{ width: 160 }} />
              </a>
              <ul className="nav nav-pills nav-flush flex-sm-column mt-5 flex-row flex-nowrap mb-auto mx-auto text-center justify-content-between w-100 px-0 align-items-center">
                <li
                  className="nav-item"
                  data-tooltip-id="dashboard"
                  data-tooltip-content="Dashboard"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("dashboard");
                    }}
                    activeclassname="inactive"
                    to="/dashboard"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "dashboard" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        <img
                          src={urls === "dashboard" ? dashboardw : dashboard}
                          style={{ width: 15, marginLeft: 6 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "dashboard"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Dashboard
                      </div>
                    </div>
                  </NavLink>
                </li>
                <li
                  className="nav-item"
                  data-tooltip-id="employees"
                  data-tooltip-content="employees"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("employees");
                    }}
                    activeclassname="inactive"
                    to="/employees"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "employees" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        <img
                          src={urls === "employees" ? dashboardw : dashboard}
                          style={{ width: 15, marginLeft: 6 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "employees"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Employees
                      </div>
                    </div>
                  </NavLink>
                </li>
                <li
                  className="nav-item"
                  data-tooltip-id="role_permissions"
                  data-tooltip-content="role_permissions"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("role_permissions");
                    }}
                    activeclassname="inactive"
                    to="/role_permissions"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "role_permissions" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        <img
                          src={
                            urls === "role_permissions"
                              ? MyProjectsw
                              : MyProjects
                          }
                          style={{ width: 15, marginLeft: 6 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "role_permissions"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Roles & Permissions
                      </div>
                    </div>
                  </NavLink>
                </li>

                {/* <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyProjects"
                  data-tooltip-content="MyProjects"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyProjects");
                    }}
                    activeclassname="inactive"
                    to="/my-projects"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyProjects" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyProjects" ? MyProjectsw : MyProjects}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyProjects"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        My Projects
                      </div>
                    </div>
                  </NavLink>
                </li>
                <li
                  className="nav-item mt-2"
                  data-tooltip-id="ProjectsAllocation"
                  data-tooltip-content="ProjectsAllocation"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("ProjectsAllocation");
                    }}
                    activeclassname="inactive"
                    to="/project-allocation"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "ProjectsAllocation" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={
                            urls === "ProjectsAllocation"
                              ? ProjectsAllocationw
                              : ProjectsAllocation
                          }
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "ProjectsAllocation"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Projects Allocation
                      </div>
                    </div>
                  </NavLink>
                </li>
                <li
                  className="nav-item mt-2"
                  data-tooltip-id="Portfolio"
                  data-tooltip-content="Portfolio"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("Portfolio");
                    }}
                    activeclassname="inactive"
                    to="/portfolio"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "Portfolio" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "Portfolio" ? Portfoliow : Portfolio}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "Portfolio"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Portfolio
                      </div>
                    </div>
                  </NavLink>
                </li> */}
                {/* <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyApproval"
                  data-tooltip-content="MyApproval"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyApproval");
                    }}
                    activeclassname="inactive"
                    to="/my-approval"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyApproval" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyApproval" ? MyApprovalw : MyApproval}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyApproval"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        My Approval
                      </div>
                    </div>
                  </NavLink>
                </li> */}
                {/* <Tooltip place="right" variant="info" id="dashboard" /> */}
              </ul>

              <ul id="lb" className="nav nav-pills ">
                <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyApproval"
                  data-tooltip-content="MyApproval"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyApproval");
                    }}
                    activeclassname="inactive"
                    to="/my-approval"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyApproval" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyApproval" ? Setting : Setting}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyApproval"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Setting
                      </div>
                    </div>
                  </NavLink>
                </li>

                <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyApproval"
                  data-tooltip-content="MyApproval"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyApproval");
                    }}
                    activeclassname="inactive"
                    to="/my-approval"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyApproval" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyApproval" ? Logout : Logout}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyApproval"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Logout
                      </div>
                    </div>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
